export default __webpack_public_path__ + "static/media/jack.e52c4371.png";